<template>
    <div class="modal-content">
        <div class="modal-header p-b-0">
			<button type="button" class="close" data-dismiss="modal" aria-hidden="true">×</button>
		</div>

        <div class="modal-body p-b-0 p-t-0">
            <div v-if="content === 'finish_profile'" class="text-center">
                <h2 class="text-center m-b-30">Conclua seu <b>Perfil</b></h2>

                <img class="profile_img m-b-20" src="/images/profile.svg" alt="" />

                <p class="m-t-20">Para que você contacte essa pessoa, precisamos que complete seu perfil no WebQuarto. Não se preocupe,
                    é bem rápido e você precisará fazer isso apenas uma vez.</p>

                <div class="row m-t-60">
                    <div class="col-xs-12 col-sm-6 m-b-10">
                        <button @click="closeModal()" class="btn btn-block btn-lg w-lg btn-white waves-effect waves-light">Deixar para depois</button>
                    </div>
                    <div class="col-xs-12 col-sm-6 m-b-10">
                        <button id="start_form" @click="goToForm()" class="btn btn-block btn-lg w-lg btn-success waves-effect waves-light ladda-button">
                            <span class="ladda-label">Concluir Perfil</span>
                        </button>
                    </div>
                </div>
            </div>

            <div v-if="content === 'user_form'">
                <user-form :user="user" v-on:proceed="goToRoommateForm()"></user-form>
            </div>

            <div v-if="content === 'roommate_form'">
                <roommate-form
                    @close="closeModal()"
                    :plocation="location"
                    :prent_price="rent_price"
                    :start_from="start_from"
                    :user="user"
                    :load_roommate="start_from === 0"
                ></roommate-form>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: [
        'location',
        'open_from',
        'rent_price'
    ],
    data() {
        return {
            content: 'finish_profile',
            user: {
                first_name: '',
                last_name: '',
                gender: null,
                birthdate: '',
                phone: '',
                cellphone: '',
                photo_url: '',
                has_photo: false,
                show_phone: null
            }
        }
    },
    computed: {
        start_from() {
            if (this.open_from === 'start') {
                return 0;
            } else {
                return 2;
            }
        }
    },
    created() {
        if (this.open_from === 'start') {
            this.content = 'roommate_form';
        }
    },
    methods: {
        closeModal() {
            this.$emit('close-modal');
        },
        goToRoommateForm() {
            this.content = 'roommate_form';
        },
        goToForm() {
            let l = Ladda.create(document.querySelector('#start_form'));
            l.start();

            axios.get('/user/get').then(({ data }) => {
                l.stop();
                this.user = data;
                
                if (!this.user.birthdate || !this.user.gender) {
                    this.content = 'user_form';
                } else {
                    this.content = 'roommate_form';
                }
            }).catch(function () {
                l.stop();
            });
        },
    }
}
</script>

<style lang="scss">
    .modal-header {
        border-bottom: none !important;
    }
    .profile_img {
        width: 54px;
    }
    .m-t-60 {
        margin-top: 60px;
    }
</style>
